import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgLogbook = (props) => /* @__PURE__ */ _jsx("svg", {
	width: props.width ?? props.size ?? "1em",
	height: props.height ?? props.size ?? "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "type=logbook",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M1 14.6806H3.60228C3.83026 14.6806 4.02937 14.5264 4.08639 14.3057L7.05917 2.79769C7.18695 2.30304 7.88682 2.29586 8.02472 2.78779L13.049 20.7108C13.1809 21.1813 13.8399 21.2027 14.0021 20.7418L17.7342 10.1362C17.8829 9.71342 18.4699 9.68482 18.6591 10.0911L20.6613 14.3917C20.7433 14.5679 20.9201 14.6806 21.1146 14.6806H23",
			stroke: "currentColor",
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		})
	})
});
export default SvgLogbook;
